import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useSettings } from "@/context/SettingsContext";
import { PlanCard } from "@/components/PlanCard";

export default function Plans() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { settings } = useSettings();

  const selectPlan = (plan) => {
    if (!user) navigate("/register");
    else navigate(`/payment/${encodeURIComponent(plan.name)}`);
  };

  return (
    <div className="vw-container py-14 md:py-20">
      <div className="text-center mb-12">
        <span className="vw-label">Subscription Plans</span>
        <h1 className="font-display text-4xl sm:text-5xl font-black text-white mt-2">Pick the plan that wins for you</h1>
        <p className="mt-3 text-slate-400 max-w-2xl mx-auto">
          Credit plans give you a fixed number of analyses. Day passes unlock unlimited analyses for a set time.
        </p>
      </div>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
        {(settings?.plans || []).map((p) => (
          <PlanCard key={p.name} plan={p} onSelect={selectPlan} />
        ))}
      </div>
    </div>
  );
}
